import React, { useCallback, useState } from 'react';
import { Header } from 'arag-ui-lib';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import questionProjections from '../../../projections/question';
import { Layout, Button } from 'arag-ui-lib';
import styles from './headerContent.module.scss';
import { useHistory } from 'react-router-dom';
import useWindowSize from '../../../hooks/useWindowSize';
import GENERAL_FUNCTIONS from '../../../utils/functions/functions';
import authentication from '../../../utils/auth/react-azure-adb2c';
import applicationUserProjections from '../../../projections/applicationUser';
import * as actions from '../../../actions';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '../../icons/languageIcon';
import * as action from '../../../actions';

const HeaderContent = () => {
    const dispatch = useDispatch();
    const apiApplicationSettings = useSelector(
        state => state.applicationSettings.apiApplicationSettings,
    );
    const questionsExists = useSelector(questionProjections.questionsExists);
    const applicationUserFullName = useSelector(
        applicationUserProjections.applicationUserFullName,
    );
    const applicationUser = useSelector(
        state => state.applicationUser.applicationUserDetails,
    );
    const unAuthorisedDetails = useSelector(
        state => state.applicationUser.unAuthorisedDetails,
    );
    const accessToken = useSelector(state => state.applicationUser.accessToken);
    const history = useHistory();
    const size = useWindowSize();
    const { t, i18n } = useTranslation();
    const [headerKey, setHeaderKey] = useState(0);
    const areButtonsDisabled = !!GENERAL_FUNCTIONS.getEnvironmentByWindowUrl();

    const closeLanguageMenu = useCallback(() => {
        setHeaderKey(key => key + 1);
    }, []);

    const handleLanguageChange = useCallback(
        payload => {
            closeLanguageMenu();
            dispatch(actions.updateLanguageApplicationUser(payload));
        },
        [closeLanguageMenu, dispatch],
    );

    const handleUnauthorisedLanguageChange = useCallback(
        payload => {
            closeLanguageMenu();
            dispatch(action.fetchUnauthorisedUserWordings(payload));
        },
        [closeLanguageMenu, dispatch],
    );

    const menuItems =
        applicationUserFullName &&
        !apiApplicationSettings.isSwitchingLanguageEnabled
            ? [
                  {
                      key: 'username',
                      label: applicationUserFullName,
                      options: [
                          {
                              key: 'first',
                              label: t('editProfile'),
                              onClick: () => authentication.editProfile(),
                          },
                          {
                              key: 'second',
                              label: t('signOut'),
                              divided: true,
                              onClick: () => handleLogout(),
                          },
                      ],
                  },
              ]
            : apiApplicationSettings.isSwitchingLanguageEnabled &&
                applicationUserFullName &&
                apiApplicationSettings.languages?.length > 1
              ? [
                    {
                        key: 'language',
                        label: [
                            <div id="languageDropdown">
                                {' '}
                                <LanguageIcon />
                                <span>
                                    {
                                        apiApplicationSettings?.languages?.find(
                                            x =>
                                                x.id ===
                                                applicationUser?.languageId,
                                        )?.isO6391
                                    }
                                </span>
                            </div>,
                        ],
                        options: apiApplicationSettings.languages.map(
                            language => ({
                                key: language.code,
                                label: language.isO6391,
                                onClick: () =>
                                    handleLanguageChange({
                                        languageId: language.id,
                                    }),
                            }),
                        ),
                    },
                    {
                        key: 'username',
                        label: applicationUserFullName,
                        options: [
                            {
                                key: 'first',
                                label: t('editProfile'),
                                onClick: () => authentication.editProfile(),
                            },
                            {
                                key: 'second',
                                label: t('signOut'),
                                divided: true,
                                onClick: () => handleLogout(),
                            },
                        ],
                    },
                ]
              : apiApplicationSettings.isSwitchingLanguageEnabled &&
                  apiApplicationSettings.languages?.length > 1 &&
                  unAuthorisedDetails?.languageId
                ? [
                      {
                          key: 'language',
                          label: [
                              <div id="languageDropdown">
                                  {' '}
                                  <LanguageIcon />
                                  <span>
                                      {
                                          apiApplicationSettings?.languages?.find(
                                              x =>
                                                  x.id ===
                                                  unAuthorisedDetails?.languageId,
                                          )?.isO6391
                                      }
                                  </span>
                              </div>,
                          ],
                          options: apiApplicationSettings.languages.map(
                              language => ({
                                  key: language.code,
                                  label: language.isO6391,
                                  onClick: () =>
                                      handleUnauthorisedLanguageChange({
                                          payload: { languageId: language.id },
                                      }),
                              }),
                          ),
                      },
                  ]
                : null;

    const logoutAction = useCallback(
        payload => dispatch(actions.logout()),
        [dispatch],
    );

    const handleLogout = () => {
        authentication.signOut();
        logoutAction();
    };

    if (!apiApplicationSettings || _.isEmpty(apiApplicationSettings)) {
        return null;
    }

    const goToLocation = location => {
        window.open(location, '_blank');
    };

    const buttons = i18n.exists('aragButtons')
        ? accessToken
            ? JSON.parse(t('aragButtons', { returnObjects: true }))
            : JSON.parse(t('aragButtons', { returnObjects: true })).filter(
                  x => x.code !== 'claimsList',
              )
        : null;

    return (
        <React.Fragment>
            <Header
                key={headerKey}
                mainImage={apiApplicationSettings.aragImageHeroArea}
                mainCollapsedImage={
                    apiApplicationSettings.aragCollapsedImageHeroArea
                }
                telephone={t('aragTelephoneNumber')}
                headerTitle={t('aragHeaderText')}
                subTitle={t('aragSubText')}
                isCollapsed={questionsExists}
                onLogoClick={() => history.push('/')}
                menuItems={menuItems}
            />
            {Array.isArray(buttons) ? (
                !questionsExists ? (
                    <Layout color="yellow">
                        <div className={styles['info-buttons']}>
                            {buttons?.map((button, index) => {
                                const isDisabled = areButtonsDisabled && button.code !== 'claimsList';
                                return (
                                    <Button
                                        key={index}
                                        variant={'quinary'}
                                        label={
                                            size.width >
                                            apiApplicationSettings.mobileScreenSizeWidth
                                                ? button.titleForBigScreens
                                                : button.titleForSmallScreens
                                        }
                                        onClick={
                                            isDisabled
                                                ? undefined
                                                : button.isExternal
                                                  ? () => goToLocation(button.url)
                                                  : () => history.push(button.url)
                                        }
                                        disabled={isDisabled}
                                    />
                                );
                            })}
                        </div>
                    </Layout>
                ) : (
                    <div className={'row'}>
                        <div
                            className={`${styles['info-buttons-without-ribbon']}`}
                        >
                            {Array.isArray(buttons) &&
                                buttons?.map((button, index) => {
                                    const isDisabled = areButtonsDisabled && button.code !== 'claimsList';
                                    return (
                                        <Button
                                            key={index}
                                            variant={'quinary'}
                                            label={
                                                size.width >
                                                apiApplicationSettings.mobileScreenSizeWidth
                                                    ? button.titleForBigScreens
                                                    : button.titleForSmallScreens
                                            }
                                            onClick={
                                                isDisabled
                                                    ? undefined
                                                    : button.isExternal
                                                      ? () => goToLocation(button.url)
                                                      : () => history.push(button.url)
                                            }
                                            disabled={isDisabled}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                )
            ) : null}
        </React.Fragment>
    );
};

export default HeaderContent;
